export default __webpack_public_path__ + "static/media/phone-icon.f046e3ff.svg";